export default __webpack_public_path__ + "static/media/paper-question.1939736c.svg";